import React, { useState } from 'react';
import Input from './RegisterDomainInput';
import RegisterDomainTable from './RegisterDomainTable';
import { getDomainAvailable } from '../../services/domain';

// const domains = [
//   { id: "1", name: "noxtton.com", status: "available", price: "12" },
// ];

// const suggested = [
//   { id: "1", name: "noxtton.ge", status: "available", price: "12" },
//   { id: "2", name: "noxtton.io", status: "available", price: "12" },
//   { id: "3", name: "noxtton.app", status: "available", price: "12" },
//   { id: "4", name: "noxtton.design", status: "available", price: "12" },
// ];

const availableTld = ['.com', '.ge', '.com.ge', '.net'];

const DomainAvailability = ({ data }) => {
  return (
    <div style={{ marginTop: '24px' }}>
      <RegisterDomainTable data={data} />
    </div>
  );
};

const SuggestedDomains = ({ data }) => {
  return (
    <div style={{ marginTop: '24px' }}>
      <div style={{ float: 'left', paddingBottom: '16px' }}>Suggested</div>
      <div style={{ marginTop: '48px' }}>
        <RegisterDomainTable data={data} />
      </div>
    </div>
  );
};

const RegisterDomain = () => {
  const [domainName, setDomainName] = useState('');
  const [tld, setTld] = useState('.com');
  const [domainAvailability, setDomainAvailability] = useState(null);
  const [isSearchEnabled, setSearchEnabled] = useState(true);

  async function checkAvailability() {
    setSearchEnabled(false);
    setDomainAvailability(null);

    try {
      const resp = await getDomainAvailable(domainName, tld);
      const { available, info, suggested } = resp.data;

      setDomainAvailability({
        available,
        info: {
          ...info,
          available
        },
        suggested
      });

      // console.error(resp);
    } catch (err) {
      console.error(err);
    } finally {
      setSearchEnabled(true);
    }
  }

  return (
    <div
      style={{
        alignItems: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}
    >
      <div style={{ alignSelf: 'center', width: '770px' }}>
        <Input
          availableTld={availableTld}
          isButtonEnabled={isSearchEnabled}
          name={domainName}
          onSearch={() => checkAvailability()}
          setName={(event) => setDomainName(event.target.value)}
          setTld={(event) => setTld(event.target.value)}
          tld={tld}
        />
        {domainAvailability && <DomainAvailability data={[domainAvailability.info]} />}
        {domainAvailability && domainAvailability.suggested.length > 0 && (
          <SuggestedDomains data={domainAvailability.suggested} />
        )}
      </div>
    </div>
  );
};

export default RegisterDomain;
